export const socialsData = {
    github: 'https://github.com/vasogoma',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/vasogoma/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: '',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}